import cx from 'classnames'
import React, { HTMLProps } from 'react'
import * as styles from '../styles/components/caption-text.module.scss'

export type CaptionTextProps = HTMLProps<HTMLDivElement>

const CaptionText = ({ className, ...rest }: CaptionTextProps) => {
    return (
        <div className={cx(styles.caption, className)} {...rest} />
    )
}

export default CaptionText
